module.exports = __webpack_public_path__ + "img/amanda-vick-eRAq9asBIy4-unsplash.12ea8aac.jpg";